import React from 'react';
import Cursor from '../../Shared/Cursor/Cursor';
import Footer from '../../Shared/Footer/Footer';
import Navigation from '../../Shared/Navigation/Navigation';
import About from '../About/About';
import Banner from '../Banner/Banner';
import Contact from '../Contact/Contact';
import Fiverr from '../Fiverr/Fiverr';
import Client from '../MyClient/Client';
import Projcets from '../Projcets/Projcets';

const Home = () => {
    return (
        <div style={{ padding: '0px', margin: '0px' }}>
            <Navigation/>
            <Banner />
            <About/>
            <Projcets></Projcets>
            <Fiverr/>
            <Contact />
            <Client></Client>
            <Footer/>
        <div> </div>
      </div>
    );
};

export default Home;